import React, { lazy } from "react";
import { interviewRoutes } from "@/features/interview/routes/interviewRoutes";
import RouterErrorBoundary from "../errors/RouterErrorBoundary/RouterErrorBoundary";

const NotFound = lazy(() => import("../errors/NotFound/NotFound"));

export const routerConfig = [
  ...interviewRoutes,
  {
    path: "*",
    element: <NotFound />,
    errorElement: <RouterErrorBoundary />,
  },
];
